export default __webpack_public_path__ + "static/media/Outline.9a318ccc.svg";